import React from 'react';

interface IProps {
  placeholder?: string;
  value?: string;
  onChange: any;
  name: string;
  label?: string;
  disabled?: boolean;
  maxLength?: number;
}

export const Input = ({
  placeholder,
  value,
  onChange,
  name,
  label,
  disabled,
  maxLength,
}: IProps) => (
  <>
    {label && <label>{label}</label>}
    <input
      disabled={disabled}
      {...(maxLength && { maxLength })}
      className="tw-h-10 tw-rounded-md tw-w-full tw-border tw-px-4 tw-py-3 focus:tw-border-primary tw-outline-0"
      placeholder={placeholder}
      name={name}
      onChange={onChange}
      value={value || ''}
    />
  </>
);
